import { breakpoint } from '../mixins/breakpoints';
import { css, DefaultTheme } from 'styled-components';

export const hideFor = (breakpointKey: string, only: boolean = false) => {
  return css`
    ${breakpoint(breakpointKey, only ? 'only' : undefined)} {
      display: none !important;
    }
  `;
};

export const showFor = (breakpointKey: string, only: boolean = false) => {
  if (only) {
    const getValues = (theme: DefaultTheme) => {
      const breakpointKeys = Object.keys(theme.grid.breakpoints);
      const lowerBound = theme.grid.breakpointValues[breakpointKey] - 1;
      const nextBreakpointKeyIndex = breakpointKeys.indexOf(breakpointKey) + 1;
      const nextBreakpointKey =
        nextBreakpointKeyIndex != 0
          ? breakpointKeys[nextBreakpointKeyIndex]
          : undefined;
      const upperBound = nextBreakpointKey
        ? theme.grid.breakpoints[nextBreakpointKey]
        : undefined;
      return {
        lowerBound,
        upperBound,
        nextBreakpointKey,
      };
    };

    return css`
      ${(p) => {
        const { lowerBound, upperBound, nextBreakpointKey } = getValues(
          p.theme
        );
        if (!upperBound && nextBreakpointKey) {
          return css`
            ${breakpoint(nextBreakpointKey, 'down')} {
              display: none !important;
            }
          `;
        } else {
          return css`
            @media screen and (max-width: ${lowerBound}px),
              screen and (min-width: ${upperBound}) {
              display: none !important;
            }
          `;
        }
      }}
    `;
  } else {
    const getValue = (theme: DefaultTheme) =>
      theme.grid.breakpointValues[breakpointKey] - 0.00125;

    return css`
      @media screen and (max-width: ${(p) => getValue(p.theme) - 0.5}px) {
        display: none !important;
      }
    `;
  }
};

export default css`
  .hide-for-small {
    @media screen and (min-width: ${(p) => p.theme.grid.breakpoints.small}) {
      display: none !important;
    }
  }
  .hide-for-medium {
    @media screen and (min-width: ${(p) => p.theme.grid.breakpoints.medium}) {
      display: none !important;
    }
  }
  .hide-for-large {
    @media screen and (min-width: ${(p) => p.theme.grid.breakpoints.large}) {
      display: none !important;
    }
  }
  .hide-for-xlarge {
    @media screen and (min-width: ${(p) => p.theme.grid.breakpoints.xlarge}) {
      display: none !important;
    }
  }
  .show-for-small {
    @media screen and (max-width: ${(p) =>
        p.theme.grid.breakpointValues.small - 0.00125}px) {
      display: none !important;
    }
  }
  .show-for-medium {
    @media screen and (max-width: ${(p) =>
        p.theme.grid.breakpointValues.medium - 0.00125}px) {
      display: none !important;
    }
  }
  .show-for-large {
    @media screen and (max-width: ${(p) =>
        p.theme.grid.breakpointValues.large - 0.00125}px) {
      display: none !important;
    }
  }
  .show-for-large {
    @media screen and (max-width: ${(p) =>
        p.theme.grid.breakpointValues.large - 0.00125}px) {
      display: none !important;
    }
  }
  .show-for-xlarge {
    @media screen and (max-width: ${(p) =>
        p.theme.grid.breakpointValues.large - 0.00125}px) {
      display: none !important;
    }
  }
`;
